import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { baseUrl, customHeaders, umsUrl, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { SUPPORT_TICKET, SUPPORT_TICKET_SUCCESS, SUPPORT_TICKET_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';

function* getSupportTicket({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];
    const { userId } = payload.data;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/admin/user/${userId}/support-tickets`,
      method: 'GET',
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
      params: payload?.urlParams,
    });

    if (response.status === 200) {
      yield put({
        type: SUPPORT_TICKET_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPPORT_TICKET_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPPORT_TICKET_ERROR, payload: error });
  }
}

export function* watchSupportTicket() {
  yield takeEvery(SUPPORT_TICKET, getSupportTicket);
}

function* watchSupportTicketSaga() {
  yield all([fork(watchSupportTicket)]);
}

export default watchSupportTicketSaga;
